import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import styled from "styled-components";
function ContactForm() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_1y8h49e', 'template_havwka4', form.current, '86svO8w5I3nbsTXtt')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
      }, (error) => {
          console.log(error.text);
      });
  };
  return (
    <StyledContactForm>
    
   
    <form ref={form} onSubmit={sendEmail}>
    <h1 >Contact-Us</h1>
      <label>Name</label>
      <input type="text" name="user_name" required />
      <label>Email</label>
      <input type="email" name="user_email" required />
      <label>Message</label>
      <textarea name="message" required />
      <input type="submit" value="Send" />
    </form>
    </StyledContactForm>
  )
}

export default ContactForm

// Styles
const StyledContactForm = styled.div`
  /* width: 400px; */
  width: 100%;
  form {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    /* width: 100%; */
     width:400px;
    margin: 0 auto;
    font-size: 16px;
    
    h1{
      font-size: 30px;
      display: flex;
  justify-content: center;
  align-items: center;
    }
    input {
      width: 100%;
      height: 35px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);
      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }
    textarea {
      max-width: 100%;
      min-width: 100%;
      width: 100%;
      max-height: 100px;
      min-height: 100px;
      padding: 7px;
      outline: none;
      border-radius: 5px;
      border: 1px solid rgb(220, 220, 220);
      &:focus {
        border: 2px solid rgba(0, 206, 158, 1);
      }
    }
    label {
      margin-top: 1rem;
    }
    input[type="submit"] {
      margin-top: 2rem;
      cursor: pointer;
      background: rgb(20, 0, 254);
      color: white;
      border: none;
    }
  }
`;